var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<script type=\"text/javascript\" src=\"https://pay.google.com/gp/p/js/pay.js\"></script> <div ng-if=\"isLoadBtn && pay.data.getService.service.masterpass_enabled\"> <button ng-click=\"onGooglePaymentButtonClicked()\" ng-disabled=\"isDisabled\" class=\"google-pay-btn\" ng-class=\"{'disabled': isInvalid}\" type=\"button\"> <img src=\"" + require("../../../assets/images/google-icon-btn.svg") + "\" alt=\"google-pay-btn-icon\"> </button> </div>";
ngModule.run(["$templateCache",function(c){c.put("googlePay/templates/index.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/googlePay/templates/index.html
 ** module id = 50
 ** module chunks = 1
 **/